import * as styles from './styles.css';
import { Accordion, useDeviceType } from '@cian/ui-kit';
import { NBSP } from 'shared/constants/symbols';
import { LIST } from './constants';
import { Answer } from '../Answer';
import { clsx } from 'clsx';

export const Answers: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Вопросы и{NBSP}ответы</div>
      <Accordion
        size={device === 'desktop' ? 'M' : 'S'}
        items={LIST.map(item => ({
          title: item.question,
          content: item.answer.map((row, key) => (
            <Answer needDot={item.answer.length - 1 === key} key={key} row={row} />
          )),
        }))}
      />
    </div>
  );
};
